









































import '@/assets/scss/pages/dashboard-ecommerce.scss';

import { Component, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import { FormatMixin } from '@/mixins/FormatMixin';

export interface DamageStatistics {
  count: number;
  sumValue: number;
  open: number;
  completed: number;
  declined: number;
}

@Component
export default class DamageRegulationStatisticsCard extends mixins(FormatMixin) {
  @Prop({ required: true, type: String })
  title!: string;

  @Prop({ required: true, type: Object })
  statistics!: DamageStatistics;
}
